<div class="page-overlay" *ngIf="openOverlay" (click)="openFilterForm()"></div>
<div class="loanMobile" (click)="openFilterForm()">
  <div class="loanMobile__data">
    <p class="data__amount">{{ loanData?.value }} €</p>
    <p class="data__month">
      <span>{{ loanData?.duration }} Monate</span>
    </p>
    <p class="data__protection">
      {{ loanProtection?.name }}
    </p>
  </div>
  <div class="loanMobile__edit">
    <svg-icon src="/resultpage/assets/icons/pencil.svg" />
  </div>
</div>
<form action="" method="post" class="loan" id="loan">
  <div class="loan__amount">
    <app-input-currency
      [inputAmount]="loanData?.value"
      (amountOutput)="addLoan($event, 'value')"
    ></app-input-currency>
  </div>
  <div class="loan__period">
    <app-select
      [selectValue]="periodValue"
      [selectData]="period"
      [key]="'period'"
      (selectOutput)="addLoan($event, 'duration')"
    ></app-select>
  </div>
  <div class="loan__protection">
    <app-select
      [selectValue]="loanProtection?.name"
      [selectData]="protectionData"
      [key]="'protectionData'"
      (selectOutput)="addLoan($event, 'creditProtection')"
    ></app-select>
  </div>
  <div class="loan__button">
    <button
      type="button"
      (click)="sendLoan()"
      [class.loading]="showSpinner"
      [disabled]="showSpinner"
      aria-label="Kredit neu vergleichen"
    >
      <span *ngIf="isLoading">Angebote werden geladen...</span>
      <span *ngIf="!isLoading">neu vergleichen</span>
      <span class="loader" *ngIf="showSpinner"></span>
    </button>
  </div>
  <p class="loan__error" *ngIf="loanRequestError">
    {{ loanRequestErrorMessage }}
  </p>
</form>
